jQuery(document).ready(function ($) {

    var module_name = 'one_liner_info';
});